import Stack from "react-bootstrap/Stack";

export default function BMDBoxes({ bmdObjects, doseUnit, setShownStudyPlot }) {
  return (
    <Stack gap={2} direction="horizontal" style={{ flexWrap: "wrap" }}>
      {bmdObjects.map((object) => (
        <div className="BMD-box">
          <div className="BMD-box-header">
            {object.organ} {object.endpoint}
          </div>
          <div className="BMD-box-body">
            <div className="BMD-box-val">
              {Math.max(0, object.bmd).toFixed(2)}
            </div>
            <div className="BMD-box-unit">{doseUnit}</div>
          </div>
          <div className="BMD-box-CI">
            {"BMDL/BMDU: ["}
            {Math.max(0, object.bmd_lower).toFixed(2)}-
            {Math.max(0, object.bmd_upper).toFixed(2)}
            {"]"}
          </div>
          <div className="BMD-box-trend">
            {(100 * (1 - object.no_trend_count / object.iterations)).toFixed(1)}
            % with dose-response trend
          </div>
          <div className="BMD-box-plot">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShownStudyPlot(`${object.organ}_${object.endpoint}`);
              }}
            >
              Show Study Plot
            </a>
          </div>
        </div>
      ))}
    </Stack>
  );
}
